'use client'

import React from 'react'
import { useTableContext } from '../../../../providers'
import { CollapsePanelContent } from './CollapsePanelContent'

interface CollapseContentCellProps extends Omit<React.HTMLAttributes<HTMLTableRowElement>, 'children'> {
    isCollapsed: boolean
    children: React.ReactNode
    /**
     * Renders as `id` on the expanded content `<tr>` for assistive tech.
     * Must match `controlledRegionId` on `CollapseRowCell` (`aria-controls` → this element).
     */
    regionId?: string
    regionAriaLabel: string
}

export const CollapseContentCell = ({
    isCollapsed,
    children,
    regionId,
    regionAriaLabel,
    className: trClassName,
    ...trProps
}: CollapseContentCellProps): React.ReactElement | null => {
    const { columns, isInline } = useTableContext()

    const lastColumn = columns.at(-1)

    if (!lastColumn || !children) return null

    const rowClassName = [isInline ? 'border-x border-border-default' : '', trClassName].filter(Boolean).join(' ')

    return (
        <tr
            {...trProps}
            id={regionId}
            hidden={isCollapsed}
            aria-label={regionAriaLabel}
            className={rowClassName || undefined}
        >
            <td className="table-cell border-border-default border-b bg-shade-0" colSpan={100}>
                {!isCollapsed && <CollapsePanelContent>{children}</CollapsePanelContent>}
            </td>
        </tr>
    )
}
